import { createClient } from 'contentful'

export default createClient({
  space: 'jp43egbzhv2q',
  accessToken: 'E-8YV4HricLu-yQq-PTVKNbz2imq0MZJv7DguAbt0ZM',
})
